import { ActionIcon, Button, Divider, Stack, Tooltip } from "@mantine/core";
import { IconDotsVertical } from "@tabler/icons-react";
import PopOver from "../../../../components/View/PopOver";
import ListConvertLinkedin from "./ListConvertLinkedin";
import ListCopyToPrm from "./ListCopyToPrm";
import ListSplit from "./ListSplit";
import DuplicateRessource from "../../../../components/View/DuplicateRessource";
import {
  copyList,
  copyListToUser,
  deleteList,
  editList,
} from "../../../../api/ContactAPI";
import CopyToUser from "../../../../components/View/CopyToUser";
import ListUrlUsed from "./ListUrlUsed";
import { useLanguage } from "../../../../stores/LanguageStore";
import ListRefreshTargetingGoogle from "./ListRefreshTargetingGoogle";
import ListRefreshTargetingAll from "./ListRefreshTargetingAll";
import ItemDeleter from "../../../../components/TableComponents/ItemDeleter";
import { useNavigate, useParams } from "react-router-dom";
import ListEnrich from "./ListEnrich";
import ListEmailVerify from "./ListEmailVerify";
import { useListStore } from "../../../../stores/ListStore";
import ListDeleteKeep from "./ListDeleteKeep";
import SelectionMover from "../../../../components/TableComponents/SelectionMover";
import ListDownload from "./ListDownload";
import ItemSharer from "../../../../components/TableComponents/ItemSharer";
import { getPermission } from "../../../../functions/utilFunctions";
import ItemRemoveFromFolder from "../../../../components/TableComponents/ItemRemoveFolder";

const ListActions = ({ current, inside = false, onFinish }) => {
  const { contactListId, folderId } = useParams();
  const setLoadProfile = useListStore((s) => s.setLoadProfile);
  const lang = useLanguage((s) => s.language);
  const handleFinish = (closeMenu) => {
    closeMenu?.();
    setLoadProfile(true);

    setTimeout(() => {
      onFinish?.();
    }, 100);
  };

  const navigate = useNavigate();
  const handleDeleteDone = (handleClose) => {
    if (contactListId === current.id.toString()) {
      navigate(
        folderId ? `/contact-lists/folder/${folderId}` : `/contact-lists`
      );
    }
    handleFinish(handleClose);
  };

  return (
    <>
      <PopOver
        opener={(handleOpen, ref) =>
          inside ? (
            <Button
              className="toolbar-action-button"
              variant="light"
              justify="start"
              ref={ref}
              leftSection={<IconDotsVertical size={18} />}
              onClick={handleOpen}
              style={{
                borderBottomRightRadius: 4,
              }}
            >
              {lang.table.more_actions}
            </Button>
          ) : (
            <Tooltip label={lang.table.more_actions}>
              <ActionIcon
                variant="subtle"
                ref={ref}
                color="primary"
                onClick={handleOpen}
              >
                <IconDotsVertical size={18} />
              </ActionIcon>
            </Tooltip>
          )
        }
        popoverChildren={(handleClose) => (
          <Stack gap={0}>
            {getPermission("displayContactListExport") && (
              <ListDownload current={current} closeMenu={handleClose} />
            )}

            <DuplicateRessource
              current={current}
              onFinish={() => handleFinish(handleClose)}
              closeMenu={handleClose}
              handler={copyList}
              responseField={"contact_list_id"}
            />

            <CopyToUser
              current={current}
              onFinish={() => handleClose()}
              closeMenu={handleClose}
              handler={copyListToUser}
              responseField={"contact_list_id"}
            />

            <ListSplit
              current={current}
              onFinish={() => handleFinish(handleClose)}
              closeMenu={handleClose}
            />

            <ListCopyToPrm
              current={current}
              onFinish={() => handleFinish(handleClose)}
              closeMenu={handleClose}
            />

            <Divider />

            <ListConvertLinkedin
              current={current}
              onFinish={() => handleFinish(handleClose)}
              closeMenu={handleClose}
            />

            <ListRefreshTargetingAll
              current={current}
              onFinish={() => handleFinish(handleClose)}
              closeMenu={handleClose}
            />

            <ListRefreshTargetingGoogle
              current={current}
              onFinish={() => handleFinish(handleClose)}
              closeMenu={handleClose}
            />

            <ListUrlUsed
              current={current}
              onFinish={() => handleFinish(handleClose)}
              closeMenu={handleClose}
            />

            <ListEnrich
              current={current}
              onFinish={() => handleFinish(handleClose)}
              closeMenu={handleClose}
            />

            <ListEmailVerify
              current={current}
              onFinish={() => handleFinish(handleClose)}
              closeMenu={handleClose}
            />

            <ListDeleteKeep
              current={current}
              onFinish={() => handleFinish(handleClose)}
              closeMenu={handleClose}
            />

            <SelectionMover
              handleEdit={editList}
              setTableLoading={() => handleFinish(handleClose)}
              ids={[current]}
              folderType={"ContactList"}
              isRowAction
            />

            <ItemSharer
              current={current}
              getEditFunction={() => editList}
              onFinish={() => handleFinish(handleClose)}
            />

            {folderId && folderId !== "none" && (
              <ItemRemoveFromFolder
                title_bold={`${current.name} #${current.id}`}
                handleEdit={editList}
                id={current.id}
                onFinish={() => handleDeleteDone(handleClose)}
                isButton
              />
            )}

            <ItemDeleter
              title_bold={`${current.name} #${current.id}`}
              handleDelete={deleteList}
              deletedMessage={lang.contact_lists.delete_success}
              id={current.id}
              disabled={
                !current?.delete_permission &&
                !current?.permission?.delete_permission
              }
              onFinish={() => handleDeleteDone(handleClose)}
              isButton
            />

            {/* <Divider /> */}

            {/* <ListEnrich
              current={current}
              onFinish={() => handleFinish(handleClose)}
              closeMenu={handleClose}
            /> */}

            {/* <ListEmailVerify
              current={current}
              onFinish={() => handleFinish(handleClose)}
              closeMenu={handleClose}
            /> */}

            {/* <IceBreaker
              current={current}
              onFinish={() => handleFinish(handleClose)}
              inMenu
              closeMenu={handleClose}
            /> */}

            {/* <ListTranslate
              current={current}
              onFinish={() => handleFinish(handleClose)}
              closeMenu={handleClose}
            /> */}

            {/* <ListDeleteKeep
              current={current}
              onFinish={() => handleFinish(handleClose)}
              closeMenu={handleClose}
            /> */}
          </Stack>
        )}
        anchorOrigin={
          inside
            ? { horizontal: "right", vertical: "bottom" }
            : { horizontal: "right", vertical: "center" }
        }
        transformOrigin={
          inside
            ? { horizontal: "right", vertical: "top" }
            : { horizontal: "left", vertical: "center" }
        }
        sx={{ zIndex: "200 !important" }}
      />
    </>
  );
};

export default ListActions;
